// extracted by mini-css-extract-plugin
export default {"pageLayout":"la-z","mainContent":"ma-z","activeSidebar":"na-z","columnLayout":"oa-z","columnLayoutFill":"pa-z","columnLayoutLast":"qa-z"};